import { render, staticRenderFns } from "./Statusbar.vue?vue&type=template&id=5c2d3172&"
import script from "./Statusbar.vue?vue&type=script&lang=js&"
export * from "./Statusbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports